/**
 * A mobil menü drawer használatának mérése.
 *
 * Mit mér (minden esemény paraméterében: menu = "mobile_drawer"):
 * - menu_open        - a drawer megnyitása
 * - menu_close       - a drawer bezárása (method: x_button | backdrop | swipe | escape)
 * - menu_item_click  - kategória/link érintése (menu_level 1-3, menu_item, menu_path, destination)
 * - menu_banner_click - ünnep banner gombja / "kisebb ajándékok" link (banner)
 * - menu_footer_click - lábléc gombjai: fiók, kedvencek, kosár, kapcsolat, rendeléskövetés (item)
 * - menu_tool_click  - eszköz-gombok: Ajándékkereső varázspálca (tool)
 * - menu_search      - keresés a drawer tetején (search_term; source: typed)
 * - menu_popular_click - "Népszerű keresések" csip a kereső alatt (item)
 * - menu_suggest_click - gépelés közbeni gyűjtemény-javaslat (item = a gyűjtemény neve, vagy search_all)
 *
 * Hova küldi:
 * - Shopify.analytics.publish: a Shopify "Customer events" rendszerébe. Ide egy Custom Pixel
 *   iratkozhat fel az adminban (Settings -> Customer events), és onnan továbbíthatja GA4-be / Meta-ba.
 *   A Shopify saját GA4 és Meta csatornái sandboxolt pixelek, ezeket a téma kódja közvetlenül nem éri el.
 * - window.dataLayer: ha később Google Tag Manager kerül az oldalra, a már odaküldött események is
 *   feldolgozhatók.
 *
 * Személyes adatot nem küld: csak a menüpontok neve/útvonala és a keresőszöveg kerül az eseményekbe.
 *
 * A "melyik elemre kattintottak" a meglévő osztályokból derül ki (menu-drawer__menu-item--mainlist/
 * --parent/--child), a banner-, lábléc-, eszköz- és népszerű-elemeken pedig data-menu-track="banner|footer|tool|popular" és
 * data-menu-track-label jelzi a típust.
 */

const MENU_NAME = 'mobile_drawer';
const drawerDetails = document.getElementById('Details-menu-drawer-container');

function publish(eventName, params) {
  const payload = { ...params, menu: MENU_NAME };
  try {
    window.Shopify?.analytics?.publish?.(eventName, payload);
  } catch (_) {
    /* a mérés soha nem törheti el a menüt */
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  } catch (_) {
    /* ugyanígy */
  }
}

function textOf(element) {
  if (!element) return '';
  const textElement = element.querySelector('.menu-drawer__menu-item-text') ?? element;
  return (textElement.textContent ?? '').replace(/\s+/g, ' ').trim();
}

function menuLevel(item) {
  if (item.matches('.menu-drawer__menu-item--mainlist')) return 1;
  if (item.matches('.menu-drawer__menu-item--parent')) return 2;
  if (item.matches('.menu-drawer__menu-item--child')) return 3;
  return 0;
}

/**
 * "Kinek keresel? > Nőknek > Anyának" jellegű útvonal. Az 1. szint címét az almenü vissza gombja,
 * a 2. szintét a lenyíló (accordion) fejléce adja.
 */
function menuPath(item) {
  const titles = [];
  const submenu = item.closest('.menu-drawer__submenu');
  if (submenu) titles.push(textOf(submenu.querySelector('.menu-drawer__back-button')));
  const accordion = item.closest('accordion-custom');
  if (accordion && !item.matches('summary')) titles.push(textOf(accordion.querySelector('summary')));
  titles.push(textOf(item));
  return titles.filter(Boolean).join(' > ');
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;

    // Bezárás módjai (X gomb, háttérre koppintás, lehúzás, Escape): ebből látszik majd, kell-e az X gomb.
    if (target && target.closest('.menu-drawer__backdrop')) {
      publish('menu_close', { method: 'backdrop' });
      return;
    }

    if (!target || !target.closest('.menu-drawer')) return;

    if (target.closest('.menu-drawer__close-button')) {
      publish('menu_close', { method: 'x_button' });
      return;
    }

    const tracked = target.closest('[data-menu-track]');
    if (tracked) {
      const group = tracked.getAttribute('data-menu-track');
      const label = tracked.getAttribute('data-menu-track-label') ?? '';
      if (group === 'banner') publish('menu_banner_click', { banner: label });
      if (group === 'footer') publish('menu_footer_click', { item: label });
      if (group === 'tool') publish('menu_tool_click', { tool: label });
      if (group === 'popular') publish('menu_popular_click', { item: label });
      if (group === 'suggest') publish('menu_suggest_click', { item: label });
      return;
    }

    const item = target.closest('.menu-drawer__menu-item');
    if (!item) return;
    const level = menuLevel(item);
    if (level === 0) return;
    publish('menu_item_click', {
      menu_level: level,
      menu_item: textOf(item),
      menu_path: menuPath(item),
      destination: item.getAttribute('href') ?? '',
    });
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target instanceof Element ? event.target.closest('[data-menu-search]') : null;
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    publish('menu_search', { search_term: (input?.value ?? '').trim(), source: 'typed' });
  },
  true
);

if (drawerDetails) {
  drawerDetails.addEventListener('toggle', () => {
    if (drawerDetails.open) publish('menu_open', {});
  });
}

// Lehúzásra záródás: az assets/menu-drawer-swipe.js jelzi
window.addEventListener('menu-drawer:swipe-close', () => publish('menu_close', { method: 'swipe' }));

// Escape: csak akkor számít bezárásnak, ha a drawer nyitva volt. (Ha a kereső lebegő panelje nyelte el az
// Escape-et, a keyup eseménye idáig el sem ér, így az nem számít bezárásnak.)
document.addEventListener('keyup', (event) => {
  if (event.key === 'Escape' && drawerDetails?.open && drawerDetails.contains(event.target)) {
    publish('menu_close', { method: 'escape' });
  }
});
